import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_CONFIG } from 'config/app.config';
import { SpinnerService } from 'app/core/services/spinner/spinner.service';
import { NotificationType } from 'app/shared/models/notification-type';
import { ErrorHandlerService } from 'app/shared/services/error-handler/error-handler.service';
import { NotificationService } from 'app/shared/services/notification/notification.service';
import { UtilityService } from 'app/shared/services/utility/utility.service';
import { ValidationService } from 'app/shared/services/validation/validation.service';
import { ChangePasswordService } from '../services/change-password.service';

@Component({
    selector: 'upsc-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit {

    public formGroup: UntypedFormGroup;
    public validationMessages = false;
    public alpha: string = '';
    public numeric: string = '';
    public length: string = '';
    public blank: string = '';
    public isConfirmPasswordValid = false;
    public isPasswordValid = false;
    public isTokenValid = false;
    public success = false;
    //TODO: Move it to validation service
    public regularExp = {
        containsNumber: /\d+/,
        containsAlphabet: /[a-zA-Z]/,
    };
    protected readonly APP_CONFIG = APP_CONFIG;
    private token = '';
    private passwordControl = 'password';
    private validValue: string = 'url(\'../../../assets/icons/valid-value.png\')';
    private invalidValue: string = 'url(\'../../../assets/icons/invalid-value.png\')';

    public constructor(private router: Router,
                       private formBuilder: UntypedFormBuilder,
                       private validationService: ValidationService,
                       private activatedRoute: ActivatedRoute,
                       private spinnerService: SpinnerService,
                       private notificationService: NotificationService,
                       private errorHandlerService: ErrorHandlerService,
                       private changePasswordService: ChangePasswordService,
                       private readonly utilityService: UtilityService,
    ) {
        this.activatedRoute.params.subscribe(params => {
            this.token = params['token'];
        });
    }

    public get supportTel(): string {
        const currentDomainName = this.utilityService.getCurrentDomainName();
        switch (true) {
            case currentDomainName.includes('upscapitalde.com'):
                return '+49 69 6630 8330';
            case currentDomainName.includes('upscapitaluk.com'):
                return '+44 20 7949 0144';
            case currentDomainName.includes('upscapitalfr.com'):
                return '+33 1 73 01 84 55';
            case currentDomainName.includes('upscapitalit.com'):
                return '+39 02 4527 9099';
            default:
                return '+1 (888) 683-2300';
        }
    }

    public onSubmit(event, formValue): void {
        if (this.formGroup.valid) {
            this.spinnerService.show();
            this.changePasswordService.changePassword(this.token, this.formGroup.controls.password.value).subscribe(response => {
                this.success = true;
                this.spinnerService.hide();
            }, error => {
                this.spinnerService.hide();
                this.notificationService.notify(
                    this.errorHandlerService.getHttpErrorMessage(error),
                    'Failed Password Reset',
                    NotificationType.ERROR);
            });
        }
    }

    public BackToLogin() {
        this.router.navigate(['/login']);
    }

    public ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
                password: ['', Validators.compose([Validators.required,
                    Validators.minLength(APP_CONFIG.minPasswordLength),
                    this.validationService.containsAlphabet(),
                    this.validationService.containsNumber()])],
                confirmPassword: ['', Validators.compose([Validators.required])],
            },
            {
                validators: this.validationService.isMatching('password', 'confirmPassword'),
            });

        this.formGroup.controls.password.valueChanges.subscribe(value => {
            if (value) {
                this.validatePassword(value);
            } else {
                this.validatePassword('');
            }
        });

        this.formGroup.controls.password.statusChanges.subscribe(status => {
            this.showHideValidationMessages(this.formGroup.controls.password.status);
        });
        this.formGroup.controls.confirmPassword.statusChanges.subscribe(status => {
            if (status === 'VALID') {
                this.isConfirmPasswordValid = true;
            } else {
                this.isConfirmPasswordValid = false;
            }
        });
    }

    public validatePassword(value): void {
        this.alpha = this.regularExp.containsAlphabet.test(value) ? this.validValue : this.invalidValue;
        this.numeric = this.regularExp.containsNumber.test(value) ? this.validValue : this.invalidValue;
        this.length = value.trim().length >= APP_CONFIG.minPasswordLength ? this.validValue : this.invalidValue;
        this.blank = (value && value.trim().length > 0) ? this.validValue : this.invalidValue;
    }

    public passwordFocus(): void {
        this.showHideValidationMessages(this.formGroup.controls.password.status);
    }

    public passwordFocusOut(): void {
        this.showHideValidationMessages(this.formGroup.controls.password.status);
    }

    private showHideValidationMessages(status): void {
        if (status === 'VALID') {
            this.validationMessages = false;
            this.isPasswordValid = true;
        } else {
            this.validationMessages = true;
            this.isPasswordValid = false;
        }
    }
}
